Vue.createApp({
    data() {
        return {
            isMenuActive: false,
            isBookModalActive: false,
            isItemActive: false,
            isScrolling: false,
            header: document.getElementById("header"),
            headerHeight: null,
            activeItems: {}
        }
    },

    mounted() {
        window.addEventListener('scroll', this.handleScrolling);
        window.addEventListener('resize', this.updateHeaderHeight);
    },

    computed: {
        headerStyle() {
            return this.headerHeight ? { height: this.headerHeight } : { height: 'unset' };
        }
    },

    methods: {
        updateHeaderHeight() {
            this.headerHeight = window.getComputedStyle(header).getPropertyValue("height");
            if (this.isMenuActive) {
                var mainNav = document.getElementById("navigation");
                mainNav.style.top = this.headerHeight;
                mainNav.style.height = "calc(100% - " + this.headerHeight + ")";
            }
            if (this.isBookModalActive) {
                var bookModal = document.getElementById("book-modal");
                bookModal.style.top = this.headerHeight;
                bookModal.style.height = "calc(100% - " + this.headerHeight + ")";
            }
        },

        toggleMenu() {
            this.updateHeaderHeight();
            this.isMenuActive = !this.isMenuActive;
            this.isBookModalActive = false;
        },

        toggleBookModal() {
            this.updateHeaderHeight();
            this.isBookModalActive = !this.isBookModalActive;
            this.isMenuActive = false;
        },

        toggleNavDropdown(event, navId) {
            this.activeItems[navId] = !this.activeItems[navId];
        },

        handleScrolling() {
            if (document.documentElement.scrollTop > 50) {
                this.isScrolling = true;
                document.getElementById("header").classList.add("scrolling");
            } else {
                this.isScrolling = false;
                document.getElementById("header").classList.remove("scrolling");
            }
        },

        pageHasHeader(value) {
            if (value === true || value === "True") {
                return true;
            } else {
                return false;
            }
        }
    }

}).mount('#header');